var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLicenceSourceCls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 172 172",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 172V0h172v172z",
    style: {
      fill: "none",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#bbdefb",
      stroke: "none"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.708 43C88.887 43 75.25 56.636 75.25 73.458s13.637 30.458 30.458 30.458c16.822 0 30.459-13.636 30.459-30.458S122.53 43 105.708 43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.583 78.45c-13.853 0-25.083 11.23-25.083 25.083 0 13.853 11.23 25.083 25.083 25.083 13.853 0 25.084-11.23 25.084-25.083 0-13.853-11.23-25.083-25.084-25.083zm-93.166.383c-13.853 0-25.084 11.23-25.084 25.083 0 13.854 11.23 25.084 25.084 25.084C53.27 129 64.5 117.77 64.5 103.916c0-13.853-11.23-25.083-25.083-25.083Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.708 53.75c-12.863 0-23.291 10.428-23.291 23.292 0 12.863 10.428 23.291 23.291 23.291C75.572 100.333 86 89.905 86 77.042 86 64.178 75.572 53.75 62.708 53.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.583 71.283c-13.853 0-25.083 11.23-25.083 25.083 0 13.854 11.23 25.084 25.083 25.084 13.853 0 25.084-11.23 25.084-25.084 0-13.853-11.23-25.083-25.084-25.083z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.083 114.667c0 7.915 6.418 14.333 14.334 14.333H129c7.916 0 14.333-6.418 14.333-14.333v-3.584c0-7.915-6.417-14.333-14.333-14.333H39.417c-7.916 0-14.334 6.418-14.334 14.333z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffa000"
    },
    d: "m30 41-4 4h-4l-4-4V21h12v8l-2 2 2 2v2l-2 2 2 2z",
    transform: "matrix(1.42903 0 0 1.71482 94.703 87.666)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffa000"
    },
    d: "M38 7.8c-.5-1.8-2-3.1-3.7-3.6C31.899 3.7 28.2 3 24 3c-4.2 0-7.898.7-10.3 1.2C12 4.7 10.5 6 10 7.8c-.5 1.7-1 4.098-1 6.7 0 2.602.5 5 1 6.7.5 1.8 1.898 3.1 3.7 3.5 2.402.6 6.1 1.3 10.3 1.3 4.2 0 7.898-.7 10.3-1.2 1.802-.402 3.2-1.8 3.7-3.5.5-1.698 1-4.1 1-6.698 0-2.704-.5-5.102-1-6.801ZM29 13H19c-1.102 0-2-.898-2-2V9c0-.602 3.102-1 7-1s7 .398 7 1v2c0 1.102-.898 2-2 2z",
    transform: "matrix(1.42903 0 0 1.71482 94.703 87.666)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d68600"
    },
    d: "M23 26h2v19h-2z",
    transform: "matrix(1.42903 0 0 1.71482 94.703 87.666)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenceSourceCls);
export default __webpack_public_path__ + "static/media/licenceSourceCls.53d1b594c446c1baa01698e76d9c40ee.svg";
export { ForwardRef as ReactComponent };